import script from "./BrowseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowseCard.vue?vue&type=script&setup=true&lang=js"

import "./BrowseCard.vue?vue&type=style&index=0&id=074b26ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074b26ee"]])

export default __exports__